import React, {useRef} from "react";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import {authStore} from "../../store/authStore";
import {observer} from "mobx-react-lite";

const FtnftTerms = observer(() => {
    const ref = useRef();
    const {setTermsPopup, termsPopup} = authStore;

    const handleClose = () => {
        setTermsPopup("");
    };

    useOnClickOutside(ref, () => handleClose());
    return (
        <div className="terms-outer-body">
            <i className="icon-close" onClick={handleClose}/>
            <iframe ref={ref} className="terms-inner-body" src={termsPopup}/>
        </div>
    )
})

export default FtnftTerms;
